/**
 * Zustand store for dose logs and cumulative dose
 */

import { create } from 'zustand';
import type { DoseLog } from '../types';

interface DoseStore {
  logs: DoseLog[];
  addLog: (log: DoseLog) => void;
  setLogs: (logs: DoseLog[]) => void;
  getTotalMicroSv: () => number;
  getAnnualMicroSv: () => number;
}

const currentYear = new Date().getFullYear();

export const useDoseStore = create<DoseStore>((set, get) => ({
  logs: [],
  addLog: (log) => set((s) => ({ logs: [...s.logs, log] })),
  setLogs: (logs) => set({ logs }),
  getTotalMicroSv: () =>
    get().logs.reduce((sum, l) => sum + l.effectiveDoseMicroSv, 0),
  getAnnualMicroSv: () =>
    get().logs
      .filter((l) => new Date(l.createdAt).getFullYear() === currentYear)
      .reduce((sum, l) => sum + l.effectiveDoseMicroSv, 0),
}));
